import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types' // ES6

import Header from '../components/Header'
import Footer from '../components/Footer'
import BlockSiteAdvice from '../components/BlockSiteAdvice'
import {
    colorBrandPrimary,
    colorNeutral,
    colorNeutralDark,
    colorNeutralGrey,
    fontFamily,
} from '../global.style'
import { media } from './utils'

export const Wrapper = styled.div`
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: ${(props) => (props.hideHeader ? '0' : '90px')};
    ${media.wide`
        margin-top: ${(props) => (props.hideHeader ? '0' : '55px')};
    `}
`

export const Container = styled.div`
    width: 100%;
    overflow: auto;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
`
export const InnerContainer = styled.div`
    max-width: 1444px;
    width: 100%;

    ${media.phone`
        max-width: 100%;
        overflow-x: ${(props) => (props.noOverflow ? 'unset' : 'hidden')};
        overflow-y: ${(props) => (props.noOverflow ? 'unset' : 'hidden')};
    `}
`

export const TituloDestaque = styled.h1`
    width: 100%;
    color: ${colorBrandPrimary.marine};
    font-family: ${fontFamily.brand};
    font-size: 48px;
    font-weight: bold;
    letter-spacing: 0;
    line-height: 70.4px;
    text-align: center;
    background-image: ${(props) =>
        props.dark
            ? `url("assets/img-simplifique2.png")`
            : `url("assets/img-simplifique.png")`};
    background-position-x: 50%;
    background-position-y: bottom;
    background-repeat: no-repeat;
    padding-bottom: 24px;
`

export const CorDeFundo = styled.div`
    display: flex;
    flex: 1;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;
    border-radius: ${(props) => (props.border ? props.border : 0)};
    background-color: ${(props) =>
        props.cor === 'Azul Marinho'
            ? colorBrandPrimary.marine
            : props.cor === 'Turquesa'
            ? colorBrandPrimary.turquoise
            : props.cor === 'Cinza'
            ? colorNeutralGrey['10']
            : colorNeutral.light};

    ${(props) => {
        return props.extraDesktopCss
    }}

    ${media.phone`
        padding: ${(props) => (props.noPadding ? '0' : '0 24px 24px 24px')};
        ${(props) => {
            return props.extraMobileCss
        }}
    `}
`

export const CorDeFundoLivre = styled.div`
    display: flex;
    flex: 1;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;
    background-color: ${(props) =>
        props.cor ? props.cor : colorNeutral.light};

    ${media.phone`
        padding: ${(props) => (props.noPadding ? '0' : '0 24px')};
    `}
`

export const FimDeBloco = styled.div`
    margin-bottom: 70px;
    width: 100%;
`

export const ContainerDivider = styled.div`
    box-sizing: border-box;
    display: block;
    border-style: inset;
    border-width: 1px;
    width: 100%;
    border-color: ${colorNeutralDark['80']};
    opacity: 0.16;
`
export const ContainerDividerVertical = styled.div`
    box-sizing: border-box;
    display: block;
    border-left: inset;
    border-width: 2px;
    height: 44px;
    border-color: ${colorNeutralDark['80']};
    opacity: 0.16;
    ${media.desktop`
        height: 1px;
        width: 100%;
        border-width: 1px;
        border-style: solid;
    `}
`

export const DotBlueGray = styled.button`
    width: ${({ active }) => (active ? '32px' : '16px')};
    height: 4px;
    border-radius: 2px;
    background-color: ${({ active }) => (active ? colorBrandPrimary.turquoise : '#E5E5E5')};
    border: none;
    margin: 0 8px;
    box-shadow: 0 8px 24px 0 rgba(0, 0, 0, 0.12), 0 0 1px 0 rgba(0, 0, 0, 0.12);
`

export const DotWhiteGray = styled.button`
    width: ${({ active }) => (active ? '32px' : '16px')};
    height: 4px;
    border-radius: 2px;
    background-color: ${({ active }) =>
        active ? '#FFFFFF;' : 'rgba(255,255,255,0.4)'};
    border: none;
    margin: 0 8px;
    border-radius: 4px;
    box-shadow: 0 8px 24px 0 rgba(0, 0, 0, 0.12), 0 0 1px 0 rgba(0, 0, 0, 0.12);
`

export const Anchor = styled.a`
    display: block;
    position: relative;
    top: ${(props) => props.top};
    visibility: hidden;
`

export default function Default({ children, ...props }) {
    const [isIE, setIsIE] = useState(false)
    // const title = props.title
    // const canonical = props.canonical || props.url || '/'
    // const path = canonical.startsWith('/') ? canonical : `/${canonical}`
    useEffect(() => {
        //Assumes the user is not using IE
        var regExpVersionBrowser = -1

        const userBrowser = navigator.appName
        const userBrowserVersion = navigator.appVersion
        const regExpVersion = /((rv:\w+))/
        regExpVersionBrowser = userBrowserVersion.match(regExpVersion)
        const hasTridentInBrowserStr = userBrowserVersion.indexOf('Trident')

        //First Validation if is IE
        if (userBrowser === 'Netscape') {
            //Validate if have the word "Trident" on browser String and VersionBrowser match exists
            if (hasTridentInBrowserStr !== -1 || !!regExpVersionBrowser) {
                const userBrowserVersionNumber = regExpVersionBrowser[0].split(
                    ':'
                )
                //Verify the version of browser
                if (Number(userBrowserVersionNumber[1]) <= 11) {
                    return setIsIE(true)
                }
            }
            return setIsIE(false)
        }
    }, []);

    return isIE ? (
        <BlockSiteAdvice />
    ) : (
        <Wrapper hideHeader={props.hideHeader}>
            <Container>
                {!props.hideHeader && <Header />}
                <InnerContainer>{children}</InnerContainer>
                {!props.hideFooter && <Footer />}
            </Container>
        </Wrapper>
    )
}

Default.propTypes = {
  children: PropTypes.node.isRequired,
  title: PropTypes.string,
  canonical: PropTypes.string,
  url: PropTypes.string,
}

Default.defaultProps = {
  title: 'Quero Veloe',
  description:
      'Dê adeus às filas em pedágios e estacionamentos em shoppings, aeroportos e centros comerciais. Com Veloe, você tem caminho livre.',
}
